import React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as id from './../common/AcountingId'
import * as lb from './../common/AcountingLables'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import Datepicker from '../../../common/datePicker'
import moment from 'moment'
import { RefreshSvg } from '../../../common/svg/refresh'
import { SplitButton } from '../../../common/SplitButton'
import { AcountingHeading } from './../common/AcountingHeading'
import { appendToUrl, focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { getPartyCreditLimitTransRptData, getOwnChildBranches, getReportBranchList } from '../../../../store/reports/reports_action'
import { useEffect } from 'react'
import * as URL from '../../Reports/oldReportsUrls'
import { getBranchConfigOrEwbillinfo, updateAlertError, updateModal } from '../../../../store/common/common_action'
import { getCreditTransReportColumns } from './../common/AcountingConstants'
import { getPartyConfigTableData } from '../../../../store/generalSetting/GSAction'
import { useAtom, useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { downloadPDF } from '../../Reports/analysisReport/pdfAutotable'

const PartyCreditLimitTransactionReportNew = (props) => {
    const {
        data: { common, reports, generalSettingReducer },
        getPartyConfigTableData,
        updateAlertError,
        getOwnChildBranches,
    } = props
    const { ownChildBranches1 } = reports
    const { partyConfigTableData } = generalSettingReducer
    const reportName = 'Party Credit Limit Transaction'
    const [stateList, setStateList] = useState([])
    const [sourceCityList, setSourceCityList] = useState([])
    const [selState, setSelState] = useState([])
    const [selSourceCity, setSelSourceCity] = useState([])
    const [selParty, setSelParty] = useState([])
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [isExpanded, setIsExpanded] = useState(false)
    const [resetFlag, setResetFlag] = useState(false)
    const [resetCity, setResetCity] = useState(false)
    const [disableBtn, setDisableBtn] = useState(false)
    const [manageColumn, setManageColumn] = useState([])
    const setLoader = useSetAtom(globalLoaderAtom)
    const setAlert = useSetAtom(alertAtom)
    
    const [companySettings] = useAtom(companySettingsAtom)
    const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
    const { Table1: RoleRightTable1 = [] } = cargoRoleRights
    const [roleRightsData] = RoleRightTable1
    let { AllowViewAllBranchReport, AllowBranchInchargeRights } = { ...roleRightsData }
    const [searchParams] = useSearchParams()
    const UseFormattedLRinReports = companySettings?.UseFormattedLRinReports
    const PartyCrlTxnsPortrait = companySettings?.IsPartyCrlTxnsPortrait

    let { loginData = {} } = useToken()
    let isFromUrl = false
    if (!loginData) {
        loginData = {}
        loginData.intCompanyID = +searchParams.get('C') || 0
        loginData.intBranchCityID = +searchParams.get('CT') || 0
        loginData.strCityName = searchParams.get('CTN') || 0
        loginData.intUserID = +searchParams.get('U') || 0
        loginData.strUserName = searchParams.get('UN') || ''
        loginData.strCompanyName = searchParams.get('CN') || ''
        loginData.strBranchName = searchParams.get('BN') || ''
        AllowViewAllBranchReport = +searchParams.get('AllowViewAllBranchReport') || 0
        AllowBranchInchargeRights = +searchParams.get('AllowBranchInchargeRights') || 0
        isFromUrl = true
    }

    const { intCompanyID, IsAdmin, intBranchCityID, intUserID, strCompanyName, strCityName, IsBranchAdmin, IsMTPLAdmin } = loginData

    useEffect(() => {
        focusElemnt(id.creditTransFromDate)
    }, [])

    const uppdatedCol = getCreditTransReportColumns(UseFormattedLRinReports)
    useEffect(() => {
        let filnalcol = uppdatedCol
        if (PartyCrlTxnsPortrait === 1) {
            console.log('inside')
            filnalcol = filnalcol.filter((item) => item.isMandatory === true)
        }
        setManageColumn(filnalcol)
    }, [UseFormattedLRinReports, PartyCrlTxnsPortrait])

    useEffect(() => {
        if (!isEmpty(loginData)) {
            const branchData = {
                intUserID: intUserID,
                intCompanyID: intCompanyID,
                intIsActive: 1,
            }
            getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
        }
    }, [intUserID])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            let object = {
                intPartyID: 0,
                intCompanyID: intCompanyID,
                strPartyName: "",
                strContactPerson: "",
                intCityID: 0,
                intIsCreditParty: -1,
                intIsActive: -1,
                intIsDeleted: -1
            }
            getPartyConfigTableData(object)
        }
    }, [intCompanyID])

    useEffect(() => {
        if (!isEmpty(ownChildBranches1)) {
            if (ownChildBranches1?.length > 0) {
                const { stateList } = ownChildBranches1.reduce(
                    (acc, val) => {
                        const { StateID, StateName } = val
                        if (!acc.statesMap.has(StateID)) {
                            acc.statesMap.set(StateID, { StateID, StateName })
                            acc.stateList.push({ StateID, StateName })
                        }
                        return acc
                    },
                    {
                        statesMap: new Map(),
                        stateList: [],
                    }
                )
                setStateList([{ StateName: 'All', StateID: 0 }, ...stateList])
                setSourceCityList([{ CityName: 'All', CityID: 0 }, ...ownChildBranches1])
                const selectedState = ownChildBranches1.find(obj => obj.CityID === intBranchCityID);
                setSelState({
                    StateName: selectedState?.StateName || '',
                    StateID: selectedState?.StateID || '',
                });
                setSelSourceCity({ CityName: strCityName, CityID: intBranchCityID })
            } else {
                setStateList([])
                setSourceCityList([])
                setSelState('')
                setSelSourceCity('')
            }
        }
    }, [ownChildBranches1])
    useEffect(() => {
        if (!isEmpty(roleRightsData) && !isEmpty(loginData)) {
            setDisableBtn(
                !(
                    AllowViewAllBranchReport ||
                    AllowBranchInchargeRights ||
                    IsBranchAdmin ||
                    IsMTPLAdmin ||
                    IsAdmin
                )
            )
        }
    }, [roleRightsData])
    const criteriaHeaders = [
        { field: 'fromDate', header: 'From Booking Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Booking  Date', textAlign: 'left' },
        { field: 'selState', header: 'Select State', textAlign: 'left' },
        { field: 'selSourceCity', header: 'Select City', textAlign: 'left' },
        { field: 'selParty', header: 'Select Party', textAlign: 'left' },
    ]
    const criteriaData = {
        fromDate: fromDate.format('DD-MM-YYYY') || '',
        toDate: toDate.format('DD-MM-YYYY') || '',
        selState: selState?.StateName || '',
        selSourceCity: selSourceCity?.CityName || '',
        selParty: selParty?.Party || '',
        dataType: 'entry',
    }
    const openViewReport = (reportPayload) => {
        const rid = Date.now().toString()

        if (!window.generatedReports) {
            window.generatedReports = {}
        }

        window.generatedReports[rid] = reportPayload
        window.open(`/view-report?rid=${rid}`, '_blank')
    }
    const handleClick1 = (isPdf = false) => {
        if (selState == '' || selState == ' ') {
            updateAlertError({ show: true, msg: 'Select State', nextId: '' })
        }
        if (selSourceCity == '' || selSourceCity == ' ') {
            updateAlertError({ show: true, msg: 'Select City', nextId: '' })
        }
        if (selParty == '' || selParty == ' ') {
            updateAlertError({ show: true, msg: 'Select Party', nextId: '' })
        } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            updateAlertError({ show: true, msg: 'Selected Date Range is More Then One Month', nextId: '' })
        } else {
            setIsExpanded(true)
            const obj = {
                CompanyID: intCompanyID,
                PartyID: selParty?.PartyID,
                CityID: selSourceCity?.CityID,
                dtFromDate: fromDate.format('YYYY-MM-DD'),
                dtToDate: toDate.format('YYYY-MM-DD'),
            }
            setLoader(true)
            GetRequest(urls.getPartyCreditLimitTransReportData, obj)
                .then((res) => {
                    setLoader(false)
                    if (res.status == 'Success') {
                        if (res?.Data?.Table?.length > 0) {
                            let reportData = res?.Data?.Table?.map((val, i) => {
                                const bkgDateTime = val.BookingDateTime !== ''
                                    ? `${moment(val.BookingDateTime).format('DD-MMM-YY')}\n${new Date(val.BookingDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
                                    : 'N/A';
                                return {
                                    ...val,
                                    sno: i + 1,
                                    'FromStation^^FromBranch': `${val.FromStation}\n${val.FromBranch}`,
                                    'ToStation^^ToBranch': `${val.ToStation}\n${val.ToBranch}`,
                                    'TranDate^^TranTime': `${moment(val.TranDate).format('DD-MMM-YY') || ''}\n${new Date(val.TranDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) || ''}`,
                                    TranDate: moment(val.TranDate).format('DD-MMM-YY') || '',
                                    TranTime: new Date(val.TranDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) || '',
                                    LRNO: val.BookingDateTime !== '' ? val.LrNo : 'N/A',
                                    BookingDateTime: bkgDateTime,
                                    dataType: 'entry',
                                };
                            });
                            const mainHeader = manageColumn?.map((val) => ({
                                ...val,
                                align: val.headerSx.textAlign,
                                export: val.exportHead,
                                weight: val.weight ?? 80
                            }))
                            const reportPayload = {
                                reportName: reportName + ' Report',
                                criteriaHeaders: criteriaHeaders,
                                criteriaData: [criteriaData],
                                tableData: reportData,
                                mainHeader: mainHeader,
                                isShowManageColumn: true,
                                manageColumnID: 'creditTransReport',
                                serialNokey: 'sno',
                            }
                            if (isPdf === true) {
                                downloadPDF({
                                    reportName: reportName + ' Report',
                                    criteriaHeaders,
                                    criteriaData: [criteriaData],
                                    tableData: reportData,
                                    visibleColumns: mainHeader,
                                    loginData,
                                    hideHeader: false
                                })
                                return
                            }
                            const rid = Date.now().toString()

                            openViewReport(reportPayload)
                        } else {
                            setAlert({ show: true, msg: 'No Data Found', nextId: '' })
                            return
                        }
                    } else {
                        setAlert({ show: true, msg: 'No Data Found', nextId: '' })
                        return
                    }
                })
                .catch((err) => {
                    setAlert({ show: true, msg: err.message, nextId: '' })
                    setLoader(false)

                })
        }
    }

    const handleClick2 = () => {
        let url = URL.partyCreditLimitTransactionReport
        const urlData = URL.partyCreditLimitTransactionReportParams
        urlData.chk = loginData.BusCrsCheckSum
        urlData.intFromCityId = selSourceCity?.CityID
        urlData.intPartyId = selParty?.PartyID
        urlData.FromCity = selSourceCity?.CityName
        urlData.PartyName = selParty?.Party
        urlData.FromDate = fromDate.format('DD-MMM-YYYY')
        urlData.ToDate = toDate.format('DD-MMM-YYYY')
        urlData.intAllowExportToExcel = 1
        urlData.Mode = 4
        url = appendToUrl(url, urlData)
        window.open(url, '_blank')
    }

    const getCityList = () => {
        if (!selState.StateID) {
            return sourceCityList || []
        } else {
            const filteredCities = sourceCityList.filter((state) => state.StateID === selState.StateID)
            return [{ CityName: 'All', CityID: 0 }, ...filteredCities]
        }
    }
    function addDaysToDate(date, days) {
        const newDate = new Date(date)
        newDate.setDate(newDate.getDate() + days)
        return newDate.toISOString().split('T')[0]
    }
    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
                {!isFromUrl && <AcountingHeading reportName={reportName} />}
                <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
                    {!isFromUrl && <>
                        <Item sx={sx.itemsx}>
                            <DropDownOA
                                id={id.selectCompany}
                                label={lb.select_company}
                                defaultvalue={strCompanyName}
                                disabled={true}
                                minWidth="250px"
                                width="300px"
                            />
                        </Item>
                        <Item sx={sx.itemsx} className="disabled-wrapper">
                            <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
                                GO
                            </Button>
                        </Item>
                    </>}
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={`From Booking Date`}
                            id={id.creditTransFromDate}
                            dateChange={(date) => {
                                setFromDate(date)
                                focusElemnt(id.toDate)
                            }}
                            width='100%'
                            startDate={'2022-01-01'}
                            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={'To Booking Date'}
                            id={id.toDate}
                            dateChange={(date) => {
                                setToDate(date)
                                focusElemnt(disableBtn ? id.creditTransSplitButton : id.stateId)
                            }}
                            width='100%'
                            startDate={'2022-01-01'}
                            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            id={id.stateId}
                            label={'Select State'}
                            data={stateList || []}
                            defaultvalue={selState?.StateName}
                            idKey={`StateID`}
                            dataKey={`StateName`}
                            onSelect={(val) => {
                                setSelState(val)
                                setIsExpanded(false)
                                setResetCity(true)
                            }}
                            isObjArr={true}
                            width={isFromUrl ? '100%' : '310px'}
                            nextId={id.srcCity}
                            prevId={id.toDate}
                            resetFlag={resetFlag}
                            disabled={disableBtn}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            id={id.srcCity}
                            label={'Select City'}
                            data={getCityList()}
                            defaultvalue={selSourceCity?.CityName}
                            idKey={`CityID`}
                            dataKey={`CityName`}
                            onSelect={(val) => {
                                setIsExpanded(false)
                                setSelSourceCity(val)
                                setResetCity(false)
                            }}
                            isObjArr={true}
                            searchPlaceholder={`Search By City`}
                            width={isFromUrl ? '100%' : '310px'}
                            nextId={id.srcBranch}
                            prevId={id.stateId}
                            resetFlag={resetCity || resetFlag}
                            disabled={disableBtn}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            id={id.srcBranch}
                            label={'Select Party'}
                            data={partyConfigTableData || []}
                            defaultvalue={selParty?.Party}
                            dataKey={`Party`}
                            idKey={`PartyID`}
                            onSelect={(val) => {
                                setIsExpanded(false)
                                setSelParty(val)
                            }}
                            isObjArr={true}
                            searchPlaceholder={`Search By Party`}
                            width={isFromUrl ? '100%' : '310px'}
                            nextId={id.creditTransSplitButton}
                            prevId={id.srcCity}
                            resetFlag={resetCity || resetFlag}
                        />
                    </Item>
                    {isFromUrl ?
                        <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id1={id.creditSummarySplitButton}>
                            DOWNLOAD PDF
                        </Button> :
                        <>
                            <Item
                                sx={sx.itemsx}
                                onKeyDown={(e) => navigation3(e, isExpanded ? 'creditTransExcelBtn' : id.creditTransFromDate, () => handleClick1())}
                            >
                                <SplitButton
                                    options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                                    id1={id.creditTransSplitButton}
                                    prevID={disableBtn ? id.toDate : id.srcBranch}
                                    onClick1={handleClick1}
                                    onClick2={handleClick2}
                                />
                            </Item>
                            <Item
                                sx={{ ...sx.itemsx }}
                                onClick={() => {
                                    setResetFlag(!resetFlag)
                                    setSelState([])
                                    setSelSourceCity([])
                                    setSelParty([])
                                    setFromDate(moment(new Date()))
                                    setToDate(moment(new Date()))
                                }}
                            >
                                <RefreshSvg />
                            </Item>
                        </>}
                </Box>
            </Item>
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    getOwnChildBranches,
    getPartyConfigTableData,
    getBranchConfigOrEwbillinfo,
    getReportBranchList,
    getPartyCreditLimitTransRptData,
    updateAlertError,
    updateModal,
}
export default connect(mapStateToProps, mapDispatchToProps)(PartyCreditLimitTransactionReportNew)

